import { useEffect, useState } from "react";
import { Box, Tab, Typography } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import ClaimFormsTable from "../../../components/tables/ClaimFormsTable.jsx";
import ClaimFormSectionTemplatesTable from "../../../components/tables/ClaimFormSectionTemplatesTable.jsx";

const TABS = [
  { value: "claim-forms", label: "Schadenformulare" },
  { value: "section-templates", label: "Section-Templates" },
];

export default function ClaimFormIndexPage() {
  const { setBreadcrumbs } = useBreadcrumb();
  const [activeTab, setActiveTab] = useState(TABS[0].value);

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Einstellungen", path: "/admin/settings" },
      { name: "Schadenformulare", path: "/admin/claim-forms" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h1" gutterBottom>
          Schadenformulare
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Übersicht aller Schadenformulare
        </Typography>
      </Box>

      <TabContext value={activeTab}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={(_, v) => setActiveTab(v)}>
            {TABS.map((t) => (
              <Tab key={t.value} label={t.label} value={t.value} />
            ))}
          </TabList>
        </Box>

        <TabPanel value="claim-forms" sx={{ px: 0 }}>
          <ClaimFormsTable />
        </TabPanel>
        <TabPanel value="section-templates" sx={{ px: 0 }}>
          <ClaimFormSectionTemplatesTable />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
